/**
 * Contrato de tipos de notificação (alinhado ao payload futuro do socket).
 * @typedef {keyof typeof NOTIFICATION_TYPES} NotificationType
 */

export const NOTIFICATION_TYPES = {
  chat_message: "chat_message",
  new_request: "new_request",
  request_assigned: "request_assigned",
  system: "system",
  billing: "billing",
  security: "security",
  /** Metadado: chamada já tratada pelo CallContext — não duplicar som. */
  call_incoming: "call_incoming",
  /** Compat Cockpit: socket `notification` genérico */
  legacy_socket: "legacy_socket",
};

/** @param {string} v */
export function isNotificationType(v) {
  return typeof v === "string" && Object.prototype.hasOwnProperty.call(NOTIFICATION_TYPES, v);
}

/**
 * @typedef {Object} PlatformNotificationPayload
 * @property {NotificationType} type
 * @property {string} title
 * @property {string} [body]
 * @property {string} [conversationId]
 * @property {string} [deepLink] rota interna, ex. /chat/123
 * @property {string} [dedupeKey]
 * @property {boolean} [skipSound]
 * @property {boolean} [skipDesktop]
 * @property {boolean} [openLinkInNewTab] ex.: alertas do Xpro 2 (legado)
 */

export const DEFAULT_DEDUPE_TTL_MS = 12_000;
